// Tenant en perspectief bepaalt de server; de key bevat het perspectief zodat een
// wisseling niet de oude config toont. Bij uitloggen leegt authProvider de cache.
export const overviewKeys = {
  all: ['overview'] as const,
  config: (perspectiveId: string) => [...overviewKeys.all, 'config', perspectiveId] as const,
} as const;
